
import { create } from 'zustand';
import { SubscriptionTier } from '@/types/subscription';

interface SubscriptionState {
  selectedTier: SubscriptionTier | null;
  setSelectedTier: (tier: SubscriptionTier | null) => void;
  refetchSubscription: () => Promise<void>;
}

export const useSubscription = create<SubscriptionState>((set) => ({
  selectedTier: null,
  setSelectedTier: (tier) => set({ selectedTier: tier }),
  refetchSubscription: async () => {
    // This will force a re-fetch of the subscription data
    set({ selectedTier: null });
  }
}));
